module.exports = __webpack_public_path__ + "static/img/reg-bg-right.8412a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg-bg-right.jpg
// module id = 951
// module chunks = 1